<template>
  <div class="animate__animated animate__fadeInDown">
    <div class="top-bre">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="index-bre" :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="split-blog"></div>
    <!--文章载体-->
    <p v-html="loadingMarkdown(this.content)" class="markdown-body mark-p"></p>
  </div>
</template>
<script>


import {getRequest} from "@/utils/service";
import {ElMessage} from "element-plus";
import MarkdownIt from "markdown-it"
import {baseUrl} from "@/utils/request";

export default {
  name: "blogIndex",
  // eslint-disable-next-line vue/no-unused-components
  components: {},
  data() {
    return {
      blogId: '',
      title: '',
      content: '# Hello, Vue Markdown!',
      markdownRender: new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true
      })
    }
  },
  created() {
    this.baseUrl = baseUrl();
    //加载文章ID
    this.blogId = this.$route.query.eId;
    //查询文章内容
    this.getEssayByEid(this.blogId)

  },
  methods: {
    getEssayByEid(eid) {
      getRequest(this.baseUrl + '/essay/getEssayByEid?eid=' + eid)
          .then((res) => {
            let data = res.data.data;
            this.content = data.essayContent;
            this.title = data.title;
          })
          .catch(function (error) {
            ElMessage.error(error)
          })
    },
    loadingMarkdown() {
      return this.markdownRender.render(this.content)
    }
  },
  watch: {}
}
</script>

<style scoped>
.top-bre {
  margin-top: 15px;
  margin-left: 15px;
  margin-bottom: 15px;
}

.split-blog {
  margin-top: 15px;
}

.mark-p {
  padding: 10px;
}

.index-bre {
  cursor: pointer;
}
</style>